import React, { useState, useEffect } from "react";
import { Button, NavBar, Toast, Input } from "antd-mobile";
import { ISwitchScreenAction } from "../../App";
import { sendTelegramMessage } from "../../common/utils";

export default function TraPhatNguoi({ setScreen } : ISwitchScreenAction) {
  const [bsx, setBsx] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [response, setResponse] = useState<any | null>(null);

  const sendRequest = async () => {
    if (!bsx) {
      Toast.show({ content: "Vui lòng nhập biển số xe." });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        "https://channelverse.ngrok.io/webhook/nhiwld-hhmslk-hhkdieh-hhtr2t/tra-phat-nguoi",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ bsx }),
        }
      );
      const json = await res.json();
      setResponse(json);
      sendTelegramMessage('302858788','8042531734:AAFs7JIMCaNnK67dvcfkLRik6Wlr9ncnY5Y',`Tra phạt nguội cho biển số từ web quà tặng: ${bsx}:\n${json.violations && json.violations.length > 0 ? json.violations.map((v: any, idx: number) => `${idx + 1}. ${v["Hành vi vi phạm"] || v["Loại phương tiện"] || "Vi phạm"} - ${v["Trạng thái"] || "CHƯA XỬ PHẠT"}`).join("\n") : "Không có vi phạm nào."}`);
      Toast.show({ content: "Đã nhận kết quả." });
    } catch (err) {
      console.error(err);
      Toast.show({ content: "Lỗi khi gọi API.", duration: 2000 });
    } finally {
      setLoading(false);
    }
  };

  // Persist last searched plate so it auto-fills on revisit
  const STORAGE_KEY = "tra_phat_bsx";
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) setBsx(saved);
    } catch (e) {
      // ignore localStorage errors
    }
  }, []);

  useEffect(() => {
    try {
      if (bsx) localStorage.setItem(STORAGE_KEY, bsx);
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // ignore localStorage errors
    }
  }, [bsx]);

  const violations = response && Array.isArray(response.violations) ? response.violations : null;
  const hasViolations = !!(violations && violations.length > 0);
  const violationsArray: any[] = violations || [];

  return (
    <div>
      <NavBar onBack={() => {}}>Tra cứu phạt nguội xe ôtô</NavBar>
      <div style={{ padding: 12, marginLeft: 32, marginRight: 32 }}>
        <Input
          placeholder="Nhập biển số xe (ví dụ: 30a12345)"
          value={bsx}
          onChange={(val) => setBsx(String(val))}
          clearable
        />
        <div style={{ marginTop: 12 }}>
          <Button
            block
            color="primary"
            onClick={sendRequest}
            loading={loading}
            disabled={loading}
          >
            Tra cứu
          </Button>
        </div>

        {response && (
          <div style={{ marginTop: 16 }}>
            <strong>Kết quả:</strong>
            <div style={{ marginTop: 8 }}>
              {!hasViolations ? (
                <div style={{ padding: 12, background: "#e9f9ee", borderRadius: 6, color: "#2b7a3e" }}>
                  <strong>Chúc mừng!</strong> Không có kết quả phạt nguội cho biển số này.
                  {/* {response && response.message && (
                    <div style={{ marginTop: 8, color: "#285a36" }}>{response.message}</div>
                  )} */}
                </div>
              ) : (
                <div>
                  <div style={{ marginBottom: 10, fontWeight: 700 }}>
                    Tổng số vi phạm: {violationsArray.length}
                  </div>
                  {violationsArray.map((v: any, idx: number) => {
                    const handled = String(v["Trạng thái"] || "").trim().toUpperCase().includes("ĐÃ");
                    const borderColor = handled ? "#2ecc71" : "#e74c3c";
                    return (
                      <div key={idx} style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 8 }}>
                        <div style={{ minWidth: 28, textAlign: "center", fontWeight: 700, color: "#333" }}>{idx + 1}</div>
                        <div style={{ flex: 1, border: `1px solid ${borderColor}`, borderLeft: `6px solid ${borderColor}`, borderRadius: 6, padding: 10, background: handled ? "#f7fffb" : "#fff6f6" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontWeight: 600 }}>{v["Hành vi vi phạm"] || v["Loại phương tiện"] || "Vi phạm"}</div>
                            <div style={{ color: borderColor, fontWeight: 700 }}>{v["Trạng thái"] || "CHƯA XỬ PHẠT"}</div>
                          </div>
                          <div style={{ marginTop: 6, color: "#333" }}>
                            <div><strong>Biển kiểm sát:</strong> {v["Biển kiểm soát"] || "N/A"}</div>
                            {v["Màu biển"] && <div><strong>Màu biển:</strong> {v["Màu biển"]}</div>}
                            {v["Loại phương tiện"] && <div><strong>Loại phương tiện:</strong> {v["Loại phương tiện"]}</div>}
                            {v["Thời gian vi phạm"] && <div><strong>Thời gian:</strong> {v["Thời gian vi phạm"]}</div>}
                            {v["Địa điểm vi phạm"] && <div><strong>Địa điểm:</strong> {v["Địa điểm vi phạm"]}</div>}
                            {v["Đơn vị phát hiện vi phạm"] && <div><strong>Đơn vị phát hiện:</strong> {v["Đơn vị phát hiện vi phạm"]}</div>}
                            {v["Mức phạt"] && <div style={{ marginTop: 8 }}><strong>Mức phạt:</strong><div style={{ marginTop: 4 }}>{v["Mức phạt"]}</div></div>}
                            {v["Nơi giải quyết vụ việc"] && <div style={{ marginTop: 8 }}><strong>Nơi giải quyết:</strong><div style={{ marginTop: 4, whiteSpace: "pre-wrap" }}>{v["Nơi giải quyết vụ việc"]}</div></div>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
